import { isNotEmptyArray } from "@formiz/validations";
import type { TFunction } from "i18next";

export const MAX_VOICE_CLIPS = 3;

export const createVoiceClipValidationRules = (
  clips: Record<string, boolean>,
  placeholderCount: number,
  hasErroredPlaceholderClip = false,
  t: TFunction,
) => [
  {
    rule: (value: File[]) => placeholderCount > 0 || isNotEmptyArray()(value),
    message: t("voice:form.validation.clips.tooFew"),
  },
  {
    rule: (value: File[]) => value.length + placeholderCount <= MAX_VOICE_CLIPS,
    message: t("voice:form.validation.clips.tooMany", { max: MAX_VOICE_CLIPS }),
  },
  {
    rule: () => Object.values(clips).every((clip) => clip),
    message: t("voice:form.validation.clips.invalidItems"),
  },
  {
    rule: () => !hasErroredPlaceholderClip,
    message: t("voice:form.validation.clips.error.placeholder"),
  },
];
